"use client";

import React from "react";
import Image from "next/image";
import "../../public/fonts/flaticon_mycollection.css";
import appDownloadImg from "../../public/assets/download.png";
// import shape3 from "/public/images/fair-share-app/shape3.png";

const AppDownload: React.FC = () => {
  return (
    <>
      <div id="download" className="px-[15px] xl:px-[30px]">
        <div className="mx-auto max-w-[1700px] overflow-hidden rounded-[24px] border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-cyan-50 py-[60px] shadow-sm">
          <div className="container">
            <div className="grid gap-[40px] items-center grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
              <div
                className="max-w-[560px] mx-auto lg:mx-0 text-center lg:text-left rtl:lg:text-right"
                data-aos="fade-down"
                data-aos-delay="100"
                data-aos-duration="600"
                data-aos-once="false"
              >
                <h6 className="mb-[10px] inline-flex rounded-full bg-cyan-100 px-3 py-1 text-[13px] font-semibold uppercase tracking-wide text-cyan-700 md:text-[14px]">
                  Campaigns + Discover App
                </h6>

                <h2 className="mb-[20px] text-[28px] leading-[36px] text-slate-900 md:text-[36px] md:leading-[45px]">
                  Ready to Launch Campaigns and Get Discovered?
                </h2>

                <p className="text-slate-600">
                  Download Eyam to connect creators, brands, and businesses in
                  one place. Run better social campaigns, discover new
                  opportunities faster, and grow with performance insights.
                </p>

                <div className="mt-4 flex flex-row flex-wrap gap-4 justify-center">
                  <a
                    href="https://apps.apple.com/za/app/eyam-savings-investments/id6742201288"
                    target="_blank"
                    className="inline-block"
                  >
                    <div className="group flex items-center space-x-[10px] rounded-full border border-slate-300 bg-white px-[28px] py-[10px] text-slate-900 transition duration-300 ease-in-out hover:-translate-y-0.5 hover:bg-slate-100 rtl:space-x-reverse">
                      <i className="flaticon-apple text-[28px] text-slate-900"></i>
                      <div>
                        <p className="mb-[6px] text-[12px] leading-none text-slate-500">
                          available on
                        </p>
                        <h4 className="text-[15px] font-semibold leading-none text-slate-900">
                          Apple Store
                        </h4>
                      </div>
                    </div>
                  </a>

                  <a
                    href="https://play.google.com/store/apps/details?id=com.exceedit.eyam&hl=en"
                    target="_blank"
                    className="inline-block "
                  >
                    <div className="flex items-center space-x-[10px] rounded-full border border-slate-300 bg-white px-[28px] py-[10px] transition duration-300 ease-in-out hover:-translate-y-0.5 hover:bg-slate-100 rtl:space-x-reverse">
                      <i className="flaticon-play-store text-[28px] text-slate-900"></i>
                      <div>
                        <p className="mb-[6px] text-[12px] leading-none text-slate-500">
                          available on
                        </p>
                        <h4 className="text-[15px] font-semibold leading-none text-slate-900">
                          Google Play
                        </h4>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              <div
                className="relative text-center"
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-duration="600"
                data-aos-once="false"
              >
                <Image
                  src={appDownloadImg}
                  alt="Eyam mobile app for campaigns and discover"
                  className="inline-block drop-shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppDownload;
